import styled from 'styled-components';
import { SideNavColorSchemeProps, SideNavColorSchemeIndex } from '../..';
import { localTheme } from '../../../../styles/local-theme';

const colorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.spaceBlack,
  blue: localTheme.colors.lqBlue,
};

const SubCategoryPanel = styled.div<SideNavColorSchemeProps>`
  display: flex;
  flex-direction: column;
  user-select: none;

  background-color: ${(props): string => colorSchemes[props.colorScheme]};
`;

export { SubCategoryPanel };
